if (!AFRAME.components['intersect-plane']) {
	AFRAME.registerComponent('intersect-plane', {
		schema: {
			movable: {}
		},
		offset: null,
		mouse: { x: null, y: null },
		initialised: false,
		init: function() {
			this.mousemove = AFRAME.utils.bind(this.mousemove, this);
			this.mouseup = AFRAME.utils.bind(this.mouseup, this);
			this.mouseout = AFRAME.utils.bind(this.mouseout, this);
			this.el.sceneEl.addEventListener('mousemove', this.mousemove);
			this.el.sceneEl.addEventListener('mouseup', this.mouseup);
			this.el.sceneEl.addEventListener('mouseout', this.mouseout);
			this.movableAttr =
				this.el.movable.getAttribute('movable') ||
				this.el.movable.getAttribute('movablexz');
			this.raycaster = new THREE.Raycaster();
			this.offset = this.movableAttr.offset;
			this.mouse.x = null;
			this.mouse.y = null;
		},
		mousemove: function(evt) {
			var rect = evt.currentTarget.getBoundingClientRect();
			this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
			this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
		},
		tick: function() {
			if (!this.initialised) {
				this.initialised = true; // Wait 1 frame for the plane to actualy get positioned
				return;
			}
			if (this.mouse.x != null && this.mouse.y != null) {
				this.raycaster.setFromCamera(this.mouse, this.el.sceneEl.camera);
				// calculate objects intersecting the picking ray
				var intersects = this.raycaster.intersectObjects([
					this.el.object3D.children[0]
				]);
				if (intersects.length > 0) {
					if (
						intersects[0].point.x != 0 ||
						intersects[0].point.y != 0 ||
						intersects[0].point.z != 0
					) {
						var point = intersects[0].point;
						var objPos = this.el.movable.body.position;
						var deltaVec = new CANNON.Vec3(
							point.x - (objPos.x + this.offset.x),
							point.y - (objPos.y + this.offset.y),
							point.z - (objPos.z + this.offset.z)
						);
						this.el.movable.body.velocity.set(
							deltaVec.x * 10,
							deltaVec.y * 10,
							deltaVec.z * 10
						);
						this.el.movable.body.angularVelocity.set(0, 0, 0);
					}
				}
			}
		},
		mouseup: function() {
			this.el.parentNode.removeChild(this.el);
			this.mouse.x = null;
			this.mouse.y = null;
		},
		mouseout: function() {
			this.el.parentNode.removeChild(this.el);
			this.mouse.x = null;
			this.mouse.y = null;
		},
		remove: function() {
			this.el.sceneEl.removeEventListener('mousemove', this.mousemove);
			this.el.sceneEl.removeEventListener('mouseup', this.mouseup);
			this.el.sceneEl.removeEventListener('mouseout', this.mouseout);
		}
	});
}
